

/// <reference path="LicenseInvoiceLine.ts" />

// Generated class LicenseFeeInvoiceLine_ManagedObject

class LicenseFeeInvoiceLine_ManagedObject extends LicenseInvoiceLine
{
}
